import axios from 'axios';
import { card } from 'ionicons/icons';

const NEW_API_DOMAIN = "https://api.chillnstudy.com";

class Server {

    static async putPurcahse(dataB) {
        return new Promise( async (resolve, reject) => {
            let data = await Server.newApi({ method: "PUT", url: "/user/purchase", data: dataB.data }).catch(e => { });
            resolve(data ? data.data : null);
        })
    }

    static async redeemCode(code) {
        return new Promise( async (resolve, reject) => {
            let data = await Server.api({ method: "GET", url: "signPromoCode?code=" + code }).catch(e => { reject(e) });
            resolve(data ? data.data : null);
        })
    }

    static async searchPublicSets(keywords, langOne, langTwo) {
        return new Promise( async (resolve, reject) => {
            let data = await Server.api({ method: "GET", url: "searchSets?keywords=" + (keywords || "") + "&langOne=" + (langOne || "") + "&langTwo=" + (langTwo || "") }).catch(e => { });
            resolve(data ? data.data : null);
        })
    }
    
    static async getTrendingPublicSets(from, category) {
        return new Promise( async (resolve, reject) => {
            let data;
            // if (/*from === "English" &&*/ !category) {
            //     data = await axios({
            //         method: "GET",
            //         url: "https://firebasestorage.googleapis.com/v0/b/simpleflashcardmanager.appspot.com/o/discover.json?alt=media",
            //     }).catch(e => { });
            // }
            
            // if (!data) {
                data = await Server.api({ method: "GET", url: "getAllSets?source=" + from + "&category=" + (category || "") }).catch(e => { });
            // }

            resolve(data ? data.data : null);
        })
    } 

    static async getAllAdminSets() {
        return new Promise( async (resolve, reject) => {
            let data = await Server.api({ method: "GET", url: "getAllSetsAdmin", headers: { adminpass: localStorage.getItem("adminpass") } }).catch(e => { });
            resolve(data ? data.data : null);
        })
    } 

    static async updateAdminset(set) {
        return new Promise( async (resolve, reject) => {
            let data = await Server.api({ method: "POST", url: "updateAdminset", data: set, headers: { adminpass: localStorage.getItem("adminpass") } }).catch(e => { });
            resolve(data ? data.data : null);
        })
    } 

    static async getSynonym(from, text) {
        return new Promise( async (resolve, reject) => {
            let data = await Server.api({ method: "GET", url: "synonymAggregator?from=" + from + "&text=" + text }).catch(e => { });
            resolve(data ? data.data : null);
        })
    } 

    static async getContext(from, to, text) {
        return new Promise( async (resolve, reject) => {
            let data = await Server.api({ method: "GET", url: "contextAggregator?from=" + from + "&to=" + to + "&text=" + text }).catch(e => { });
            resolve(data ? data.data : null);
        })
    } 

    static async shareSet(set, cards) {
        return new Promise( async (resolve, reject) => {
            let data = await Server.api({ 
                method: "POST", 
                url: "shareSet/" + set.viewSecret, 
                data: {
                    tags: set.tags,
                    description: set.description,
                    name: set.name,
                    term: set.term,
                    definition: set.definition,
                    shareMode: set.shareMode,
                    cards: cards.map(card => {
                        return ({
                            imageLinks: card.image,
                            imageThumbnails: card.customText1,
                            customFields: card.customText2,
                            term: card.term,
                            definition: card.definition,
                            localId: card.id
                        })
                    })
                },
                headers: { editSecret: set.editSecret }
            }).catch(e => { window.toast("Failed to create share " + JSON.stringify(e), "error") });
            resolve(data ? data.data : null);
        })
    }

    static async createShareCredentials(localId) {
        return new Promise( async (resolve, reject) => {
            let data = await Server.api({ method: "POST", url: "createShareCredentials", data: { localId: localId } }).catch(e => { window.toast("Failed to create share " + JSON.stringify(e), "error") });
            resolve(data ? data.data : null);
        })
    }

    static async getPublicSet(id) {
        return new Promise( async (resolve, reject) => {
            let data = await Server.api({ method: "GET", url: "getSet/" + id }).catch(e => { });
            resolve(data && data.data ? data.data : null);
        })
    } 

    static async getPublicSet(id) {
        return new Promise( async (resolve, reject) => {
            let data = await Server.api({ method: "GET", url: "getSharedSet/" + id }).catch(e => { });
            resolve(data && data.data ? data.data : null);
        })
    } 

    static async signUp(email, username, password) {
        return new Promise( async (resolve, reject) => {
            let data = await Server.newApi({ method: "POST", url: "/user/signup", data: {
                username: username,
                email: email,
                password: password
            } }).catch(e => { });
            resolve(data ? data.data : null);
        })
    } 

    static async logIn(usernameOrEmail, password) {
        return new Promise( async (resolve, reject) => {
            let data = await Server.newApi({ method: "POST", url: "/user/login", data: {
                usernameOrEmail: usernameOrEmail,
                password: password
            } }).catch(e => { });
            resolve(data ? data.data : null);
        })
    } 

    static async deleteAccount(email, password) {
        return Server.api({ 
            method: "POST", 
            url: "deleteAccount",
            data: {
                email: email,
                password: password
            }
        })
    } 

    static async newApi(request) {
        let headers = request.headers || {};

        if (window.settings && window.settings.account && window.settings.account.username) {
            headers.username = window.settings.account.username;
            headers.password = window.settings.account.password;
        }

        return new Promise((resolve, reject) => {
            axios({
                method: request.method,
                url: NEW_API_DOMAIN + request.url,
                data: request.data,
                params: request.params,
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                headers: headers
            }).then(function (response) {
                resolve(response)
            })
            .catch(async function (error) {
                reject(error);
            });

        })
    }

    static async api(request) {

        // TO DO restore
        // const SERVER = "http://localhost:5001/simpleflashcardmanager/us-central1/"
        const SERVER = "https://us-central1-simpleflashcardmanager.cloudfunctions.net/";
        // const SERVER = "http://localhost:5001/simpleflashcardmanager/us-central1/";

        let headers = request.headers || {};

        if (window.settings && window.settings.account && window.settings.account.username) {
            headers.username = window.settings.account.username;
            headers.password = window.settings.account.password;
        }

        return new Promise((resolve, reject) => {
            axios({
                method: request.method,
                url: SERVER + request.url,
                data: request.data,
                params: request.params,
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                headers: headers
            }).then(function (response) {
                resolve(response)
            })
            .catch(async function (error) {
                reject(error);
            });

        })

    }

    static async downloadFile(link) {

        return new Promise((resolve, reject) => {
            axios({
                method: 'get',
                url: link
            }).then(function (response) {
                resolve(response)
            })
            .catch(async function (error) {
                reject(error);
            });

        })

    }

}

export default Server;
